<template>
  <el-tabs v-model="activeName" type="card" class="tabs-one" style="padding-top: 20px;">
    <el-tab-pane name="1" class="active">
      <span slot="label"><i class="el-icon"></i>顾问佣金</span>
      <commission></commission>
    </el-tab-pane>
    <el-tab-pane name="2">
      <span slot="label"><i class="el-icon"></i>佣金查询记录</span>
      <record></record>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import commission from "./commission";
  import record from "./record";
    export default {
      name: "GWCommission",
      components:{
        commission,
        record
      },
      data () {
        return {
          activeName: '1',
        }
      },
      created () {
        this.activeName = this.$route.params.active ? this.$route.params.active : '1'
      },
      methods: {

      }
    }
</script>

<style scoped>

</style>
